import React from "react";
import classNames from "classnames";
import { TEXT_CLASS_NAME } from "../Text";
import styles from "./Headline.module.scss";

type Props = {
  as?: keyof JSX.IntrinsicElements;
  className?: string;
} & React.HTMLAttributes<HTMLOrSVGElement>;

const Headline = ({ as: As = "p", className, ...props }: Props) => (
  <As
    {...props}
    className={classNames(styles.headline, TEXT_CLASS_NAME, className)}
  />
);

export default Headline;
